import React from 'react';
import PropTypes from 'prop-types';
import s from './InputErrorMessage.module.scss';
import InputAlert from '../../assets/icons/input-alert.svg';

function InputErrorMessage(props) {
  const { children, id } = props;
  return (
    <div id={id} className={s.errorMessageContainer}>
      <img className={s.errorMessageIcon} src={InputAlert} alt="" />
      <div className={s.errorMessageContent}>{children}</div>
    </div>
  );
}

InputErrorMessage.defaultProps = {
  id: '',
};

InputErrorMessage.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
};

export default InputErrorMessage;
